// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19RYR","content":"styles_content__2Ak-e"};